export const shouldCheckIndicatorAge = (ind) => {
  return !ind.exclude_from_age_checks &&
         ind.available_times &&
         ind.available_times.points &&
         ind.available_times.points.length > 1;
};



// WEBPACK FOOTER //
// ./src/utils/indicator_utils.js